"use client";

import { usePathname } from "next/navigation";
import React, { useEffect } from "react";
import Link from "next/link";
import { Menu, ConfigProvider, Drawer, Button } from "antd";
import Image from "next/image";
import MenuComponent from "./TheMenu";

const MenuDrawerComponent = ({ open, setClose, menuItems, pinnedCategory }) => {
  const pathname = usePathname();

  // Đóng menu khi đường dẫn thay đổi
  useEffect(() => {
    if (open) {
      setClose(false);
    }
  }, [pathname]); // Theo dõi sự thay đổi của pathname

  return (
    <div className="bg-prim-600 flex justify-center">
      <ConfigProvider
        theme={{
          token: {
            fontSize: 16,
            padding: 8,
            paddingXS: 8,
          },
          components: {
            Menu: {
              iconSize: 16,
            },
            Drawer: {
              padding: 8,
              paddingXS: 8,
            },
          },
        }}
      >
        <Drawer
          closeIcon={false}
          width={300}
          title={
            <Link href="/" className="!bg-[#0C1B56]">
              <img
                onClick={() => setClose(false)}
                alt="logo"
                className="logo 2xl:h-[75px] xl:h-[60px] lg:h-[40px] h-[27px] object-cover"
                src={"/images/hitech.png"}
              />
            </Link>
          }
          styles={{
            header: { padding: "32px 16px", background: "#0C1B56" },
            body: { padding: "32px 16px" },
          }}
          placement="right"
          header={null}
          onClose={() => setClose(false)}
          open={open}
        >
          <MenuComponent drawer={true} menuItems={menuItems} />
        </Drawer>
      </ConfigProvider>
    </div>
  );
};

export default MenuDrawerComponent;
